import { render, staticRenderFns } from "./ProgramAlert.vue?vue&type=template&id=4c47a046&scoped=true&"
import script from "./ProgramAlert.vue?vue&type=script&lang=js&"
export * from "./ProgramAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47a046",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c47a046')) {
      api.createRecord('4c47a046', component.options)
    } else {
      api.reload('4c47a046', component.options)
    }
    module.hot.accept("./ProgramAlert.vue?vue&type=template&id=4c47a046&scoped=true&", function () {
      api.rerender('4c47a046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/program/components/ProgramAlert.vue"
export default component.exports